import axios from 'axios';
import { API_ENDPOINTS } from '@/services/config';

let relationTypesPromise = null;

function loadRelationTypes() {
  if (!relationTypesPromise) {
    relationTypesPromise = axios
      .get(API_ENDPOINTS.graphRelationTypes)
      .then((res) => (Array.isArray(res.data) ? res.data : []))
      .catch((error) => {
        relationTypesPromise = null;
        throw error;
      });
  }
  return relationTypesPromise;
}

export async function resolveRelationTypeId(name) {
  const types = await loadRelationTypes();
  const match = types.find((type) => type.name === name);
  if (!match) {
    throw new Error(`Relation type "${name}" not found`);
  }
  return match.id;
}

/** Returns [{ edgeId, relationTypeId, relationType, node }] for edges around a node. */
export async function fetchNodeEdges(nodeId, entraId, { direction = 'outgoing', relationType } = {}) {
  try {
    const params = { entra_id: entraId, direction };
    if (relationType) params.relation_type = relationType;

    const res = await axios.get(API_ENDPOINTS.graphNodeEdges(nodeId), { params });
    const entries = Array.isArray(res.data?.edges) ? res.data.edges : [];
    return entries.map(({ edge, connected_node: node }) => ({
      edgeId: edge.id,
      relationTypeId: edge.relation_type_id,
      relationType: edge.relation_type,
      node,
    }));
  } catch (error) {
    if (error?.response?.status === 404) return [];
    throw error;
  }
}

export function createEdge({ srcNodeId, dstNodeId, relationTypeId, entraId }) {
  return axios.post(API_ENDPOINTS.graphEdges, {
    entra_id: entraId,
    src_node_id: srcNodeId,
    dst_node_id: dstNodeId,
    relation_type_id: relationTypeId,
  });
}

export function deleteEdge(edgeId, entraId) {
  return axios.delete(API_ENDPOINTS.graphEdges, {
    data: { entra_id: entraId, id: edgeId },
  });
}
